import {
  filterSystemConversationMessages,
  gptConversationRequestAdapter,
} from "../../views/chat-view/services/adapters/gpt-conversation.adapter";
import { conversationApi } from "../../views/chat-view/services/gpt-api.service";
import { getLernwerkGPTResultTrunk } from "../searchApiResults/trunk";

import {
  sendMessageGptActionFailure,
  sendMessageGptActionSuccess,
  sendMessageGptEndedAction,
  sendMessageGptStartedAction,
} from "./actions";
import { selectGPTConversationMessages } from "./selectors";

const abortController = new AbortController();

export const sendGPTmessageTrunk = (
  message,
  role = null,
  noKeywords = false
) => {
  return async (dispatch, getState) => {
    dispatch(sendMessageGptStartedAction());
    const state = getState();
    const messages = selectGPTConversationMessages(state);

    const conversationReq = gptConversationRequestAdapter(
      messages,
      message,
      role
    );

    dispatch(sendMessageGptActionSuccess(conversationReq.messages));

    if (role === "system") {
      dispatch(sendMessageGptEndedAction());
      return;
    }

    const conversationsWithoutSystem =
      filterSystemConversationMessages(conversationReq);

    try {
      const res = await conversationApi(
        conversationsWithoutSystem,
        abortController.signal
      );
      concatinanteStreamResponses(
        conversationReq?.messages,
        res?.body,
        dispatch
      );
    } catch (error) {
      console.log(error);
      dispatch(sendMessageGptActionFailure(error.message));
    }
  };
};

export const setOldConversationTrunk = (messages) => {
  return async (dispatch) => {
    dispatch(sendMessageGptActionSuccess(messages));
    dispatch(getLernwerkGPTResultTrunk(messages?.at(-1)?.content));
  };
};

const concatinanteStreamResponses = async (
  conversationMessages,
  data,
  dispatch
) => {
  if (!data) return;

  const reader = data?.pipeThrough(new TextDecoderStream()).getReader();
  const incompleteChunk = { value: "" }; // Object to store incomplete chunk

  while (reader) {
    let { done, value } = await reader.read();

    if (done) {
      break;
    }

    // if there is incomplete chunk from last iteration, put it in front of the stream value
    if (incompleteChunk.value) {
      value = incompleteChunk.value + value;
      incompleteChunk.value = "";
    }
    const chunks = value;

    if (chunks) {
      for (let chunk of chunks) {
        try {
          if (!chunk) {
            continue;
          }

          const content = chunk || "";

          conversationMessages[conversationMessages.length - 1] = {
            ...conversationMessages[conversationMessages.length - 1],
            content: `${
              conversationMessages[conversationMessages.length - 1]?.content ||
              ""
            }${content}`,
          };

          dispatch(sendMessageGptActionSuccess(conversationMessages));
        } catch (err) {
          console.log(err);
          dispatch(sendMessageGptActionSuccess(conversationMessages));
          return;
        }
      }
    }
  }
  dispatch(sendMessageGptEndedAction());
};
